import { corpusManifest, custodyLanes } from "./corpusManifest.js";

const manifestById = Object.fromEntries(corpusManifest.map((source) => [source.id, source]));

export const sourceQuotes = [
  {
    id: "sunzi-know-self-enemy",
    sourceId: "pg-sunzi-giles-1910",
    author: "Sunzi",
    work: "The Art of War",
    translator: "Lionel Giles",
    text: "know the enemy and know yourself",
    chapterOrSection: "III. Attack by Stratagem, 18",
    custodyLane: custodyLanes.PUBLIC_DOMAIN_COUNTABLE,
    sourceUrl: "https://www.gutenberg.org/ebooks/132",
    allowedUse: "short_public_domain_excerpt",
    blockedClaims: ["predictive guarantee", "all Sunzi translations counted", "professional advice"]
  },
  {
    id: "sunzi-water-weak",
    sourceId: "pg-sunzi-giles-1910",
    author: "Sunzi",
    work: "The Art of War",
    translator: "Lionel Giles",
    text: "avoid what is strong and strike at what is weak",
    chapterOrSection: "VI. Weak Points and Strong, 30",
    custodyLane: custodyLanes.PUBLIC_DOMAIN_COUNTABLE,
    sourceUrl: "https://www.gutenberg.org/ebooks/132",
    allowedUse: "short_public_domain_excerpt",
    blockedClaims: ["military advice", "predictive guarantee", "all Sunzi translations counted"]
  },
  {
    id: "bushido-rectitude-resolution",
    sourceId: "pg-bushido-nitobe-1908",
    author: "Inazo Nitobe",
    work: "Bushido, the Soul of Japan",
    translator: null,
    text: "Rectitude is the power of deciding",
    chapterOrSection: "Rectitude or Justice",
    custodyLane: custodyLanes.PUBLIC_DOMAIN_COUNTABLE,
    sourceUrl: "https://www.gutenberg.org/ebooks/12096",
    allowedUse: "short_public_domain_excerpt",
    blockedClaims: ["claim Musashi text counted", "moral authority", "all Japanese strategy counted"]
  },
  {
    id: "bushido-face-calamities",
    sourceId: "pg-bushido-nitobe-1908",
    author: "Inazo Nitobe",
    work: "Bushido, the Soul of Japan",
    translator: null,
    text: "Bear and face all calamities",
    chapterOrSection: "Self-Control",
    custodyLane: custodyLanes.PUBLIC_DOMAIN_COUNTABLE,
    sourceUrl: "https://www.gutenberg.org/ebooks/12096",
    allowedUse: "short_public_domain_excerpt",
    blockedClaims: ["psychological advice", "moral authority", "claim Musashi text counted"]
  }
];

export const sourceQuoteBlockers = [
  {
    id: "musashi-book-five-rings",
    label: "Musashi / Book of Five Rings",
    status: "LICENSED_SOURCE_NEEDED",
    reason: "No countable local public-domain Musashi source is registered; Bushido is not Musashi."
  },
  {
    id: "zhuge-liang-liu-ji",
    label: "Zhuge Liang / Liu Ji commentarial strategy",
    status: "LICENSED_SOURCE_NEEDED",
    reason: "Current references are licensed-modern or source-anchor lanes only."
  },
  {
    id: "guiguzi-master-demon-valley",
    label: "Guiguzi / Master of Demon Valley",
    status: "SOURCE_ANCHOR_ONLY",
    reason: "No lawful local text custody is registered for direct quote display."
  },
  {
    id: "yagyu-family-traditions",
    label: "Yagyu / Family Traditions on the Art of War",
    status: "LICENSED_SOURCE_NEEDED",
    reason: "No registered countable local source for quote extraction."
  }
];

export function validateSourceQuote(quote) {
  const source = manifestById[quote.sourceId];
  const errors = [];

  if (!source) errors.push("source-not-found");
  if (!quote.id || !/^[a-z0-9][a-z0-9-]*$/.test(quote.id)) errors.push("unsafe-quote-id");
  if (!quote.text || quote.text.split(/\s+/).filter(Boolean).length > 12) errors.push("quote-too-long");
  if (!quote.sourceUrl) errors.push("source-url-required");
  if (!quote.allowedUse) errors.push("allowed-use-required");
  if (!Array.isArray(quote.blockedClaims) || quote.blockedClaims.length === 0) {
    errors.push("blocked-claims-required");
  }
  if (source) {
    if (source.lane !== quote.custodyLane) errors.push("custody-lane-mismatch");
    if (source.lane !== custodyLanes.PUBLIC_DOMAIN_COUNTABLE && source.lane !== custodyLanes.LICENSED_MODERN_TRANSLATION) {
      errors.push("quote-source-not-displayable");
    }
    if (!source.allowedUses.includes("quoted_short_excerpts")) errors.push("short-excerpt-not-allowed");
    if (source.lane === custodyLanes.PUBLIC_DOMAIN_COUNTABLE && (!source.localPath || !source.sha256)) {
      errors.push("countable-source-custody-missing");
    }
  }

  return {
    valid: errors.length === 0,
    errors,
    source
  };
}

export function sourceQuoteSummary(quotes = sourceQuotes) {
  const validations = quotes.map(validateSourceQuote);
  return {
    total: quotes.length,
    valid: validations.filter((validation) => validation.valid).length,
    blockedSourceNeeds: sourceQuoteBlockers.length,
    invalid: validations.filter((validation) => !validation.valid).length
  };
}
